import * as actions from '../../actions/actionTypes';

const initialState = [];

export default function cntryInfo(state = initialState, action) {
  switch (action.type) {
    case actions.GET_CNTRY_INFO:
      return action.payload.length ? action.payload : state;
    default:
      return state;
  }
}
